function initFaqAccordion(scope = document) {
  const faqItems = scope.querySelectorAll('.faq-item');

  faqItems.forEach(item => {
    const btn = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');

    if (!btn || !answer) return;

    // Remove previous event listener by cloning (clean state)
    const newBtn = btn.cloneNode(true);
    btn.parentNode.replaceChild(newBtn, btn);

    newBtn.addEventListener('click', () => {
      const isOpen = item.classList.contains('active');

      faqItems.forEach(i => {
        i.classList.remove('active');
        const ans = i.querySelector('.faq-answer');
        ans.style.height = '0px';
        ans.classList.remove('open');
      });

      if (!isOpen) {
        item.classList.add('active');
        answer.style.height = answer.scrollHeight + 'px';
        answer.classList.add('open');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initFaqAccordion();
});

document.addEventListener('shopify:section:load', function (event) {
  initFaqAccordion(event.target);
});